import { ImMNElement, MNElement } from '../elements/elementModelTypes';
import { propIn } from '../utils/immutableHelper';

export enum TaskListContentVersion {
    Legacy = 'V1',
    SingleEditor = 'V2',
}

const getPersistedTaskListContentVersion = propIn(['content', 'version']);

/**
 * Gets the persisted task list content version, defaulting old task lists to the legacy format.
 */
export const getTaskListContentVersion = (element: MNElement | ImMNElement): TaskListContentVersion =>
    getPersistedTaskListContentVersion(element) === TaskListContentVersion.SingleEditor
        ? TaskListContentVersion.SingleEditor
        : TaskListContentVersion.Legacy;

/**
 * Checks whether a task list should render with the single-editor implementation.
 */
export const isSingleEditorTaskList = (element: MNElement | ImMNElement): boolean =>
    getTaskListContentVersion(element) === TaskListContentVersion.SingleEditor;
